// ————————————————————————————————————————————— LIB. ————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

import eventbus from "../../../../../app/lib/jGia/jGia/src/eventbus";
import getComponentFromElement from "../../../../../app/lib/jGia/jGia/src/getComponentFromElement";

// ———————————————————————————————————————————— UTIL. ————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

// ...

// ———————————————————————————————————————— EVENT HANDLERS ———————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

// ...

// ———————————————————————————————————————————— ASSETS ———————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

const logArgs = { eventName: "init_flkty", inline: true, disabled: false };
const msgs = {
  start: ["init. flkty"],
  end: ["init. flkty", "init. success"],
  no_el: ["init. flkty", "no valid DOM el. provided"],
};

// —————————————————————————————————————— INIT. METHOD DEF. ——————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

export default function init_flkty() {
  //////////////////////////////////////////// Setup /////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////

  const { wrpr_slides, slides, btn_prev, btn_next, dots } = this.ref;
  this.logger("init", msgs.start, "action", logArgs);

  // Guard...
  if (!this.validate_refEl(wrpr_slides)) return this.cancel_featInit(msgs.no_el);

  //////////////////////////////////////////// ACTION ////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////

  const inst_flickity = new Flickity(wrpr_slides, {
    cellSelector: "[g-ref='slides']",
    wrapAround: true,
    // autoPlay: 5000,
    cellAlign: "center",
    contain: false,
    pageDots: false,
    prevNextButtons: false,
    selectedAttraction: 0.01,
    friction: 0.2,
    draggable: true,
    imagesLoaded: true,
    lazyLoad: 1,
    on: {
      /////////// Slider ready event hdl. ////////////
      ////////////////////////////////////////////////

      // ready: () => {
      //   if (this.options.logs) console.log("Slider ready.");
      // },

      /////////// Slide change event hdl. ////////////
      ////////////////////////////////////////////////

      change: (index_activeSlide) => {
        this.setState({ index_activeSlide });

        // Pause any video in the slide that is leaving; play any in the incoming slide.
        slides.forEach((el_slide, i) => {
          const el_player = el_slide.querySelector("[g-component='VideoPlayer']");
          if (!el_player) return;
          const videoPlayer = getComponentFromElement(el_player);
          if (!videoPlayer?.api) return;
          if (i === index_activeSlide) videoPlayer.api.play();
          else videoPlayer.api.pause();
        });
      },
    },
  });

  if (btn_prev) btn_prev.addEventListener("click", () => inst_flickity.previous());
  if (btn_next) btn_next.addEventListener("click", () => inst_flickity.next());

  ///////////// Slide overlay init. //////////////
  ////////////////////////////////////////////////

  // Gather slide img srcs.
  const imgSrcs = slides.map((el_slide) => {
    const img = el_slide.querySelector("img");
    return img ? img.src : null;
  });

  slides.forEach((el_slide) => {
    // Adjust slide overlay width to rendered img. width
    const overlay = el_slide.querySelector("[data-ref='overlay']");
    const media = el_slide.querySelector("img") || el_slide.querySelector("video");
    if (!overlay || !media) return;
    const w_img = media.getBoundingClientRect().width;
    overlay.style.width = `${w_img}px`;

    // Open-lightbox btn. init //
    const btn_openLightbox = el_slide.querySelector("[data-ref='btn_openLightbox']");

    if (btn_openLightbox)
      btn_openLightbox.addEventListener("click", () => {
        eventbus.emit("Lightbox.api.insertSlides", { imgSrcs });
        eventbus.emit("Lightbox.api.show");
      });
  });

  ////////////////// Dots init. //////////////////
  ////////////////////////////////////////////////

  if (dots && dots.length > 0) {
    dots.forEach((dot, i) => dot.addEventListener("click", () => inst_flickity.select(i)));
  }

  /////////////////////////////////////////// Conclude ///////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////

  this.logger("init", msgs.end, "success", logArgs);
}

// ———————————————————————————————————————————————————————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //
